/* eslint-disable */
import _ from 'underscore';
import ko from 'knockout';
import dlbDataSource from '@bingads-webui-static-legacy/double-list-box-datasource';
var viewModel = function (options) {
  var self = this;
  self.options = options;
  self.strings = _.defaults(options.strings || ({}), {
    maximumSelectionAlertString: ko.observable(),
    maxSelectedItems: ''
  });
  self.features = _.defaults(options.features || ({}), {
    maxSelectedItemsCount: options && options.features && _.isNumber(options.features.maxSelectedItemsCount) ? options.features.maxSelectedItemsCount : -1
  });
  self.customData = options.customData || ({});
  self.processItem = options.processItem || (function (item) {
    return item || ({});
  });
  self.showMaximumSelectionAlert = ko.observable(false);
  self.selectedData = self._createSelectedData();
  self.sourceData = self._createSourceData(self.selectedData);
  self.sourceDataSource = self.sourceData.dataSource;
  self.selectedDataSource = self.selectedData.dataSource;
  if (self.selectedDataSource && _.isFunction(self.selectedDataSource.read)) {
    self.selectedDataSource.read();
  }
  self.selectedItems = ko.observable(self.selectedData.getFilterData());
  self._initializeFilter();
  self._initializeSourceItemsCount();
  self.refreshSource = _.bind(self.sourceData.refresh, self.sourceData);
  self.selectedItemsCount = ko.computed(function () {
    return _.isArray(this.selectedItems()) ? this.selectedItems().length : 0;
  }, self);
  self.hasMaxSelectedItems = ko.computed(function () {
    if (self.features.maxSelectedItemsCount > 0 && self.selectedItemsCount() >= self.features.maxSelectedItemsCount) {
      return true;
    } else {
      return false;
    }
  });
  self.showMaximumSelectionAlert = ko.computed(function () {
    if (self.hasMaxSelectedItems() && !_.isEmpty(self.strings.maximumSelectionAlertString())) {
      return true;
    } else {
      return false;
    }
  });
  self.hasMaxSelectedItems.subscribe((function (newValue) {
    var value = newValue ? 'disabled' : '';
    _.each(self.sourceData.getData(), (function (item) {
      this.sourceData.setItemProperty(item, 'disabled', value);
    }).bind(this));
  }).bind(this));
};
viewModel.prototype.selectItem = function (item, silent) {
  var self = this, changed = false;
  if (self.hasMaxSelectedItems()) {
    return changed;
  } else {
    changed = self.selectedData.addIfNotExists(item);
  }
  if (changed) {
    if (!silent || self.features.maxSelectedItemsCount > 0) {
      self._notifySubscribers();
    }
    self.sourceData.setItemProperty(item, 'selected', 'selected');
  }
  return changed;
};
viewModel.prototype.deselectItem = function (item, silent) {
  var self = this;
  if (self.selectedData.removeIfExists(item)) {
    self.sourceData.setItemProperty(item, 'selected', '');
    if (!silent || self.features.maxSelectedItemsCount > 0) {
      self._notifySubscribers();
    }
  }
};
viewModel.prototype.setSelection = function (selection) {
  var self = this;
  var newSelectionIds = _.map(selection, function (item) {
    return self.sourceData.getItemId(item);
  });
  var oldSelectionIds = _.map(self.selectedItems(), function (item) {
    return self.selectedData.getItemId(item);
  });
  var toSelect = _.filter(selection, function (item) {
    return !_.contains(oldSelectionIds, self.sourceData.getItemId(item));
  });
  var toDeselect = _.difference(oldSelectionIds, newSelectionIds);
  _.each(toSelect, function (item) {
    self.selectItem(item, true);
  });
  _.each(toDeselect, function (item) {
    self.deselectItem(item, true);
  });
  if (toSelect.length > 0 || toDeselect.length > 0) {
    self._notifySubscribers();
  }
};
viewModel.prototype.selectAll = function () {
  var sourceItems = this.sourceData.getFilterData(), self = this, changed = false;
  _.each(sourceItems, function (item) {
    if (self.selectItem(item, true)) {
      changed = true;
    }
  });
  if (changed) {
    self._notifySubscribers();
  }
};
viewModel.prototype.deselectAll = function () {
  this.setSelection([]);
};
viewModel.prototype.refreshItem = function (item) {
  var self = this;
  self.sourceData.refreshItem(item);
  self.selectedData.refreshItem(item);
};
viewModel.prototype._notifySubscribers = function () {
  this.selectedItems(this.selectedData.getFilterData());
};
viewModel.prototype._initializeFilter = function () {
  var self = this;
  self.filterText = ko.observable('');
  self.filterText.subscribe(function (newValue) {
    self.sourceData.filter(newValue);
  });
};
viewModel.prototype._initializeSourceItemsCount = function () {
  var self = this, total = self.sourceDataSource.total();
  self.showEmptyMessage = ko.observable(false);
  self.sourceItemsCount = ko.observable(total);
  self.sourceDataSource.bind('change', function () {
    var newTotal = self.sourceDataSource.total();
    self.sourceItemsCount(newTotal);
    newTotal === 0 ? self.showEmptyMessage(true) : self.showEmptyMessage(false);
  });
};
viewModel.prototype._createSelectedData = function () {
  var self = this;
  var selectedCustomActions = [];
  _.each(self.options.itemActions.selected, function (value, key) {
    selectedCustomActions.push({
      name: key,
      caption: value.caption
    });
  });
  return new dlbDataSource({
    dataItems: self.options.data.selectedItems,
    itemIdField: self.options.data.itemIdField,
    itemIdCallback: self.options.data.itemIdCallback,
    listItemSeed: (function (item, id) {
      return _.extend(this.processItem(item, id), {
        customActions: selectedCustomActions,
        strings: self.strings
      });
    }).bind(this),
    pageSize: self.features.paging ? self.options.data.selectedPageSize || self.options.data.pageSize : Math.pow(2, 31)
  });
};
viewModel.prototype._createSourceData = function (selectedDataSource) {
  var self = this;
  var sourceCustomActions = [];
  _.each(self.options.itemActions.source, function (value, key) {
    sourceCustomActions.push({
      name: key,
      caption: value.caption
    });
  });
  return new dlbDataSource({
    dataCallback: _.isFunction(self.options.data.sourceItems) ? self.options.data.sourceItems : null,
    dataItems: !_.isFunction(self.options.data.sourceItems) ? self.options.data.sourceItems : null,
    useCallbackForFetchOnly: self.options.data.useCallbackForFetchOnly,
    itemIdField: self.options.data.itemIdField,
    itemIdCallback: self.options.data.itemIdCallback,
    itemFilterField: self.options.data.itemFilterField,
    itemFilterCallback: self.options.data.itemFilterCallback,
    pageSize: self.features.paging ? self.options.data.pageSize : Math.pow(2, 31),
    listItemSeed: (function (item, id) {
      return _.extend(this.processItem(item, id), {
        customActions: sourceCustomActions,
        selected: selectedDataSource.getItemData(id) ? 'selected' : '',
        disabled: self.hasMaxSelectedItems() ? 'disabled' : '',
        strings: self.strings
      });
    }).bind(this)
  });
};
export default viewModel;

